<template>
  <div>
    <div class="dropdown flex-fill">
      <div type="text" class="form-select pointer" data-bs-toggle="dropdown">
        <span class="badge text-bg-light" v-for="s in _selected" :key="s">
          {{ s }}
          <i
            class="bi bi-x-lg"
            @click="_selected = _selected.filter((a) => a !== s)"
          ></i>
        </span>
        <template v-if="_selected.length === 0">
          <span>&nbsp;</span>
          <!-- sizing when nothing selected -->
        </template>
      </div>
      <ul class="dropdown-menu w-100">
        <li v-for="t in candidates" :key="t">
          <a
            href="javascript:0"
            class="dropdown-item small"
            @click="_selected = Array.from(new Set([..._selected, t]))"
            >{{ t }}</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
const eventName = "change";
const eventSource = "selected";

export default {
  name: "EpiMultiSelect",
  props: [eventSource, "candidates", "placeholder"],
  model: {
    prop: eventSource,
    event: eventName,
  },
  computed: {
    _selected: {
      get() {
        return this[eventSource];
      },
      set(v) {
        this.$emit(eventName, v);
      },
    },
  },
};
</script>

<style lang="stylus" scoped>
span.badge
  font-size var(--epi-font-size)
</style>
